import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=08d6cc1e&scoped=true&lang=pug&"
import script from "./Collections.vue?vue&type=script&lang=js&"
export * from "./Collections.vue?vue&type=script&lang=js&"
import style0 from "./Collections.vue?vue&type=style&index=0&id=08d6cc1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d6cc1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d6cc1e')) {
      api.createRecord('08d6cc1e', component.options)
    } else {
      api.reload('08d6cc1e', component.options)
    }
    module.hot.accept("./Collections.vue?vue&type=template&id=08d6cc1e&scoped=true&lang=pug&", function () {
      api.rerender('08d6cc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/pages/Collections.vue"
export default component.exports